import { CouponDetail } from '../../contexts/CouponContext';
import axiosRequest from '../axios';

export interface CreateCouponResponseBody {
  id: number;
  resource: {
    code: string;
    type: string;
    value: number;
    rules: {
      amount?: number;
      route?: string;
      from?: string;
      to?: string;
    };
    users: string | null;
    startAt: string;
    expiresAt: null;
    is_disposable: true;
    active: true;
    updated_at: string;
    created_at: string;
    id: number;
  };
  redirect: string;
}

export default async (detail: CouponDetail): Promise<CreateCouponResponseBody | undefined> => {
  const requestBody = {
    code: detail.code,
    type: detail.type,
    value: detail.value,
    applies: detail.applies,
    'rules->amount': detail.rules.amount,
    'rules->route': detail.rules.route,
    'rules->from': detail.rules.from,
    'rules->to': detail.rules.to,
    services: detail.services,
    users: detail.users,
    start_at: detail.startAt,
    expires_at: detail.expiresAt,
    is_disposable: detail.isDisposable,
    is_active: detail.isActive,
    viaResource: detail.viaResource,
    viaResourceId: detail.viaResourceId,
    viaRelationship: detail.viaRelationship,
  };
  try {
    const data = await axiosRequest.post(
      '/nova-api/coupons?editing=true&editMode=create',
      requestBody,
    );

    return data.data;
  } catch (e) {
    console.error('Error while running coupon restful API.', e);
  }
};
